// extracted by mini-css-extract-plugin
export default {"definitions":"StatsLegend_definitions__rHjaY","footnotes":"StatsLegend_footnotes__LVS+K"};